import { QUERY_KEYS } from "@/src/config";

export const goalQueryKeys = {
  all: [QUERY_KEYS.GOAL_LIST] as const,
  list: (params: Record<string, unknown>) =>
    [QUERY_KEYS.GOAL_LIST, params] as const,
  detail: (goalId: string) => [QUERY_KEYS.GOAL_DETAIL, goalId] as const,
  stats: () => [QUERY_KEYS.GOAL_STATS] as const,
};
